<!--			 	  -->
<!-- Visitor Selector -->
<!-- 			 	  -->
<div class="selector-main">
	<div class="selector-body">
		<!-- 				  	  	   -->
		<!-- Display Visitor Selectors -->
		<!-- 						   -->
		<div class="selector-item-body">
			<!-- 				 -->
			<!-- Facility Selector -->
			<!-- 				 -->
			<div class="selector-item">
				<div class="selector-item-label">
					<label>Facility</label>
				</div>

				<div class="selector-item-picker">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="FacilitySelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedFacility"
						(ngModelChange)="onFacilityChange($event)"
					>
						<option *ngFor="let r of lstFacility" [ngValue]="r">{{ r.FacilityCD }} - {{ r.FacilityName }}</option>
					</select>
				</div>
			</div>

			<!-- 				 -->
			<!-- Status Selector -->
			<!-- 				 -->
			<div class="selector-item">
				<div class="selector-item-label">
					<label>Visitor Status</label>
				</div>

				<div class="selector-item-picker">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="StatusSelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedStatus"
						(ngModelChange)="onStatusChange($event)"
					>
						<option *ngFor="let r of lstStatus" [ngValue]="r">
							{{ r.VisitorStatusDesc }}
						</option>
					</select>
				</div>
			</div>

			<!-- 				 -->
			<!-- Type Selector -->
			<!-- 				 -->
			<div class="selector-item">
				<div class="selector-item-label">
					<label>Visitor Type</label>
				</div>

				<div class="selector-item-picker">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="TypeSelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedType"
						(ngModelChange)="onTypeChange($event)"
					>
						<option *ngFor="let r of lstType" [ngValue]="r">
							{{ r.VisitorTypeDesc }}
						</option>
					</select>
				</div>
			</div>

			<!-- 			 -->
			<!-- Name Search -->
			<!-- 			 -->
			<div class="selector-item">
				<div class="selector-item-label">
					<label>Visitor Name</label>
				</div>

				<div class="selector-item-picker">
					<input type="text" style="width: 100%" pInputText [(ngModel)]="NameSearch" (keyup.enter)="onSearch()" />
				</div>
			</div>

			<!-- 		 	   -->
			<!-- Button Search -->
			<!-- 			   -->
			<div class="selector-item">
				<div class="selector-item-label">
					<!-- 				   -->
					<!-- Display When Busy -->
					<!-- 				   -->
					<div [style.display]="isBusy == true ? 'block' : 'none'" style="width: 20px; margin-left: 25px">
						<img class="busy-img" src="assets/images/loading.gif" />
					</div>
				</div>

				<div class="selector-item-picker">
					<button class="btn btn-primary" (click)="onSearch()">Search</button>
				</div>
			</div>
		</div>

		<!-- 				  	  -->
		<!-- Display Visitor List -->
		<!-- 					  -->
		<div class="selector-item-table">
			<!-- Note: resizableColumns breaks the multiline ability -->
			<p-table
				#mydt
				[value]="lstVisitor"
				[paginator]="true"
				[(rows)]="pagerows"
				[(first)]="pagefirst"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedVisitor"
				dataKey="PersonID"
				(onFilter)="onHandleFilter($event)"
				(onSort)="onHandleSort($event)"
				(onRowSelect)="onRowSelect($event)"
				(onRowUnselect)="onRowUnselect($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			>
				<ng-template pTemplate="header">
					<!-- 			  -->
					<!-- Sort Section -->
					<!-- 			  -->
					<tr style="height: 4rem">
						<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
						<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
						<th pSortableColumn="VisitorTypeDesc">Type<p-sortIcon field="VisitorTypeDesc"></p-sortIcon></th>
						<th pSortableColumn="VisitorStatusDesc">Status<p-sortIcon field="VisitorStatusDesc"></p-sortIcon></th>
						<th class="fixwidth-09" pSortableColumn="isIn">In Facility<p-sortIcon field="isIn"></p-sortIcon></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-rVisitorItem>
					<tr [pSelectableRow]="rVisitorItem">
						<td>
							<div class="table-data">
								{{ rVisitorItem.LastName }}
							</div>
						</td>

						<td>
							<div class="table-data">
								{{ rVisitorItem.FirstName }}
							</div>
						</td>

						<td>
							<div class="table-data">
								{{ rVisitorItem.VisitorTypeDesc }}
							</div>
						</td>

						<td>
							<div
								class="table-data"
								[ngClass]="{
									'table-data-status-1': rVisitorItem.VisitorStatusID == 1,
									'table-data-status-2': rVisitorItem.VisitorStatusID == 2,
									'table-data-status-3': rVisitorItem.VisitorStatusID == 3
								}"
							>
								{{ rVisitorItem.VisitorStatusDesc }}
							</div>
						</td>

						<td class="fixwidth-09">
							<div>
								<i
									class="pi"
									[ngClass]="{
										'pi-check-circle table-active': rVisitorItem.isIn
									}"
								></i>
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!-- 				  	   -->
		<!-- Display Visitor Photo -->
		<!-- 					   -->
		<div style="margin-left: 10px">
			<div class="image-view">
				<div [style.display]="Person_Image.length >= 10 ? 'block' : 'none'">
					<img class="image-view-img" [src]="Person_Image" />
				</div>
				<div [style.display]="Person_Image.length < 10 ? 'block' : 'none'">
					<label>No Image</label>
				</div>
			</div>

			<div>
				<label>{{ PersonName }}</label>
			</div>

			<div
				[ngClass]="{
					'table-data-status-1': PersonStatusID == 1,
					'table-data-status-2': PersonStatusID == 2,
					'table-data-status-3': PersonStatusID == 3
				}"
			>
				<label>{{ PersonStatus }}</label>
			</div>

			<div [style.display]="PersonFacilityID == 0 ? 'block' : 'none'">
				<label>All Sites</label>
			</div>
		</div>
	</div>
</div>
